module.exports = __webpack_public_path__ + "img/banner.898fb921.jpg";